import { useCallback, useState } from 'react'
import { Coordinates } from '~/types'
import { useGoogleMapsLoader } from '../useGoogleMapsLoader'

export const useGoogleMap = (center?: Coordinates) => {
  const { isLoaded } = useGoogleMapsLoader()
  const [map, setMap] = useState<google.maps.Map>(null)

  const onLoad = useCallback(
    (currentMap: google.maps.Map) => {
      if (currentMap) {
        if (center) {
          currentMap.setCenter({ lat: center.latitude, lng: center.longitude })
        }
        setMap(currentMap)
      }
    },
    [center]
  )

  const onUnmount = useCallback(() => {
    setMap(null)
  }, [])

  return { map, apiLoaded: isLoaded, mapProps: { onLoad, onUnmount } }
}
